import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import dayjs from 'dayjs';
import vueQr from 'vue-qr';
export default {
  name: 'mng_app_version',
  components: {
    vueQr: vueQr
  },
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: 'APP版本',
        addFunName: 'mngAppVersionAdd',
        modifyFunName: 'mngAppVersionModify',
        queryFunName: 'mngAppVersionQueryJoinUser',
        detailFunName: 'mngAppVersionDetail',
        sendProductionFunName: 'mngAppVersionSendProduction',
        dicTreeFunName: 'mngDictionaryLowerTree'
      },
      dicData: {
        upperCode: 'mng_app_type',
        configCategorys: [],
        configCategoryOptions: {}
      },
      searchForm: {
        page: 1,
        limit: 10,
        appType: null,
        searchKey: null,
        versionType: null,
        sortField: 'create_time'
      },
      formData: {
        id: null,
        appType: null,
        name: null,
        versionType: 'Development',
        version: null,
        downloadUrl: null,
        remark: null
      },
      rules: {
        appType: [{
          required: true,
          message: 'APP类型不能为空',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '版本名称不能为空',
          trigger: 'blur'
        }],
        versionType: [{
          required: true,
          message: '版本类型不能为空',
          trigger: 'blur'
        }],
        version: [{
          required: true,
          message: '版本号不能为空',
          trigger: 'blur'
        }],
        downloadUrl: [{
          required: true,
          message: '下载地址不能为空',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      qrCodeDialogShow: false,
      qrCodeDialogTitle: '',
      qrCodeDialogDownloadUrl: '',
      formLabelWidth: '100px',
      emptyFormData: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.$api[this.pageConfig.dicTreeFunName](this.dicData.upperCode).then(function (res) {
      if (res.data) {
        _this.dicData.configCategorys = res.data;
        for (var i = 0; i < res.data.length; i++) {
          _this.dicData.configCategoryOptions[res.data[i].code] = res.data[i].name;
        }
      }
      _this.query();
    });
  },
  methods: {
    beforeFileUpload: function beforeFileUpload(file) {
      var isApk = ['application/vnd.android.package-archive'].includes(file.type);
      if (!isApk) {
        this.$message.error('文件必须是APK格式');
      }
      return isApk;
    },
    upload: function upload(_ref) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this2.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this2.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this2.formData.downloadUrl = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    previewFile: function previewFile() {
      window.open(this.formData.downloadUrl);
    },
    removeFile: function removeFile() {
      this.formData.downloadUrl = '';
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    copyLink: function copyLink(row, column, cell, event) {
      if (column.property === 'downloadUrl') {
        var save = function save(e) {
          e.clipboardData.setData('text/plain', event.target.innerText);
          e.preventDefault();
        };
        document.addEventListener('copy', save);
        document.execCommand('copy');
        document.removeEventListener('copy', save);
        this.$message({
          message: '复制成功',
          type: 'success'
        });
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(id) {
      var _this3 = this;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this3.initFormData(res.data);
        _this3.editDialogTitle = _this3.pageConfig.editPageName + '维护';
        _this3.editDialogShow = true;
      });
    },
    send: function send(id) {
      var _this4 = this;
      this.$confirm('确定要发布该版本吗').then(function () {
        _this4.$api[_this4.pageConfig.sendProductionFunName](id).then(function (res) {
          if (res.data) {
            _this4.$message.success('发布成功');
            _this4.query();
          } else {
            _this4.$message.error('发布失败');
          }
        });
      });
    },
    qrcode: function qrcode(rowData) {
      this.qrCodeDialogTitle = '《' + rowData.name + '》_' + rowData.version + ' 下载二维码';
      this.qrCodeDialogDownloadUrl = rowData.downloadUrl;
      this.qrCodeDialogShow = true;
    },
    query: function query() {
      var _this5 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this5.tableData = res.data || [];
        _this5.totalCount = res.count;
        _this5.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this6 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this6.formData.id) {
            _this6.$api[_this6.pageConfig.modifyFunName](_this6.saveFormDataProcess(_this6.formData)).then(function (res) {
              if (res.data) {
                _this6.$message.success('编辑成功');
                _this6.initFormData(_this6.emptyFormData);
                _this6.editDialogShow = false;
                _this6.query();
              } else {
                _this6.$message.error('编辑失败');
              }
            });
          } else {
            _this6.$api[_this6.pageConfig.addFunName](_this6.saveFormDataProcess(_this6.formData)).then(function (res) {
              if (res.data) {
                _this6.$message.success('新增成功');
                _this6.initFormData(_this6.emptyFormData);
                _this6.editDialogShow = false;
                _this6.query();
              } else {
                _this6.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};